import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/useTheme';
import { Button } from '@/ui/ui/button';
import { cn } from '@/lib/utils';

interface ShellThemeToggleProps {
  className?: string;
}

export const ShellThemeToggle: React.FC<ShellThemeToggleProps> = ({ className }) => {
  const { theme, resolvedTheme, setTheme } = useTheme();

  const nextTheme = resolvedTheme === 'dark' ? 'light' : 'dark';
  const buttonLabel = nextTheme === 'dark' ? 'Switch to dark mode' : 'Switch to light mode';

  const handleToggle = () => {
    if (theme === 'system') {
      setTheme(nextTheme);
      return;
    }

    setTheme(nextTheme);
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      aria-label={buttonLabel}
      onClick={handleToggle}
      className={cn(
        'border border-sidebar-border/60 bg-sidebar-accent/70 text-sidebar-foreground shadow-sm hover:bg-sidebar-accent/90 hover:text-sidebar-foreground',
        className,
      )}
    >
      {resolvedTheme === 'dark' ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
      <span className="sr-only">{buttonLabel}</span>
    </Button>
  );
};

